export const _hasPermission = (user, features) => {
	if (!user) return false;
	const _roleMap = {
		"all": [],
		"basic": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"market-activity-chart",
			"sponsor-buildings",
			"document-search",
			"building-insights",
			"violations-tab",
			"stacking-plans",
			"owner-outreach",
			"mc-post-cards"

		],
		"advanced": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"market-activity-chart",
			"market-activity-detail",
			"resale-buildings",
			"past-sales",
			"discount-analysis",
			"price-trends",
			"stacked-report",
			"finance-tab",
			"building-management",
			"collections",
			"ownership",
			"originator",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"stacking-plans",
			"owner-outreach",
			"custom-themes",
			"mc-post-cards",
			"collection-bldg-report"
		],
		"broker": [
			"building-search",
			"sponsor-buildings",
			"resale-buildings",
			"pipeline-buildings",
			"inventory-search",
			"market-activity-chart",
			"building-management",
			"mc-resale",
			"ownership",
			"owner-outreach",
			"past-sales",
			"custom-themes",
			"broker-outreach",
			"mc-post-cards",
			"collection-bldg-report",
			"skip-trace"
		],
		"resale": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"market-activity-chart",
			"market-activity-detail",
			"building-insights",
			"violations-tab",
			"resale-buildings",
			"past-sales",
			"discount-analysis",
			"price-trends",
			"stacked-report",
			"finance-tab",
			"building-management",
			"collections",
			"ownership",
			"originator",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"stacking-plans",
			"owner-outreach",
			"custom-themes",
			"broker-outreach",
			"mc-post-cards",
			"collection-bldg-report"
		],
		"complete": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"rental-building-search",
			"market-activity-chart",
			"market-activity-detail",
			"building-insights",
			"violations-tab",
			"discount-analysis",
			"price-trends",
			"sales-agents",
			"architects",
			"developers",
			"search-firms",
			"resale-buildings",
			"pipeline",
			"pipeline-buildings",
			"building-management",
			"ownership",
			"past-sales",
			"stacked-report",
			"download-image",
			"ag-link",
			"sales-velocity",
			"collections",
			"sponsor-buildings",
			"originator",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"mc-sponsor",
			"stacking-plans",
			"owner-outreach",
			"custom-themes",
			"finance-tab",
			"offering-tab",
			"lenders",
			"broker-outreach",
			"mc-post-cards",
			"collection-bldg-report",
			"skip-trace"
		],
		"research-agents": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"rental-building-search",
			"market-activity-chart",
			"market-activity-detail",
			"building-insights",
			"violations-tab",
			"discount-analysis",
			"price-trends",
			"sales-agents",
			"architects",
			"developers",
			"search-firms",
			"resale-buildings",
			"pipeline",
			"pipeline-buildings",
			"building-management",
			"ownership",
			"past-sales",
			"stacked-report",
			"download-image",
			"ag-link",
			"sales-velocity",
			"collections",
			"sponsor-buildings",
			"originator",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"mc-sponsor",
			"stacking-plans",
			"owner-outreach",
			"custom-themes",
			"finance-tab",
			"offering-tab",
			"lenders",
			"broker-outreach",
			"mc-post-cards",
			"collection-bldg-report",
			"skip-trace"
		],
		"complete-199": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"rental-building-search",
			"market-activity-chart",
			"market-activity-detail",
			"building-insights",
			"violations-tab",
			"discount-analysis",
			"price-trends",
			"sales-agents",
			"architects",
			"developers",
			"search-firms",
			"resale-buildings",
			"pipeline",
			"pipeline-buildings",
			"building-management",
			"ownership",
			"past-sales",
			"stacked-report",
			"download-image",
			"ag-link",
			"sales-velocity",
			"collections",
			"sponsor-buildings",
			"originator",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"mc-sponsor",
			"stacking-plans",
			"owner-outreach",
			"custom-themes",
			"finance-tab",
			"offering-tab",
			"lenders",
			"broker-outreach",
			"mc-post-cards",
			"collection-bldg-report",
			"skip-trace"
		],
		"enterprise": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"rental-building-search",
			"market-activity-chart",
			"market-activity-detail",
			"building-insights",
			"violations-tab",
			"discount-analysis",
			"price-trends",
			"sales-agents",
			"architects",
			"developers",
			"lenders",
			"pipeline",
			"search-firms",
			"finance-tab",
			"offering-tab",
			"resale-buildings",
			"pipeline-buildings",
			"building-management",
			"ownership",
			"past-sales",
			"stacked-report",
			"download-image",
			"ag-link",
			"firm-contracts",
			"sales-velocity",
			"collections",
			"sponsor-buildings",
			"originator",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"mc-sponsor",
			"stacking-plans",
			"owner-outreach",
			"custom-themes",
			"broker-outreach",
			"mc-post-cards",
			"collection-bldg-report",
			"skip-trace"
		],
		"elliman-agent": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"rental-building-search",
			"market-activity-chart",
			"market-activity-detail",
			"building-insights",
			"violations-tab",
			"discount-analysis",
			"price-trends",
			"sales-agents",
			"architects",
			"developers",
			"lenders",
			"pipeline",
			"search-firms",
			"finance-tab",
			"offering-tab",
			"resale-buildings",
			"pipeline-buildings",
			"building-management",
			"ownership",
			"past-sales",
			"stacked-report",
			"download-image",
			"ag-link",
			"firm-contracts",
			"sales-velocity",
			"collections",
			"sponsor-buildings",
			"originator",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"mc-sponsor",
			"stacking-plans",
			"owner-outreach",
			"broker-outreach",
			"mc-cover-page",
			"elliman-notices",
			"studiopro",
			"skip-trace"
		],
		"admin": [
			"inventory-search",
			"inventory-analysis",
			"building-search",
			"rental-building-search",
			"market-activity-chart",
			"market-activity-detail",
			"building-insights",
			"violations-tab",
			"discount-analysis",
			"price-trends",
			"sales-agents",
			"architects",
			"developers",
			"lenders",
			"pipeline",
			"coming-soon-buildings",
			"admin-filters",
			"search-firms",
			"market-activity-error-checking",
			"admin-tools",
			"finance-tab",
			"offering-tab",
			"resale-buildings",
			"pipeline-buildings",
			"building-management",
			"ownership",
			"past-sales",
			"stacked-report",
			"download-image",
			"change-branding",
			"ag-link",
			"firm-contracts",
			"sales-velocity",
			"collections",
			"sponsor-buildings",
			"originator",
			"community-collections",
			"buyer-attorney",
			"document-search",
			"mc-resale",
			"mc-sponsor",
			"stacking-plans",
			"owner-outreach",
			"custom-themes",
			"mc-post-cards",
			"collection-bldg-report",
			"skip-trace"
		],
		"data-export": [
			"data-export"
		],
		"broker-outreach": [
			"broker-outreach"
		],
		"mc-video": [
			"mc-video"
		],
		"de-niro-custom": [
			"mc-custom-email"
		],
		"skip-trace": [
			"skip-trace"
		]
	}

	features = !Array.isArray(features) ? [features] : features;

	const userRoles = !Array.isArray(user.role) || user.role.length <= 0 ? ["basic"] : user.role.slice(0);

	userRoles.push('all');


	if (!_isNewUser(user)) {
		//userRoles.push('advanced');
	}
	//console.log(userRoles)
	let hasPermission = false;

	if (userRoles && Array.isArray(userRoles)) {
		userRoles.map(role => {
			if (_roleMap[role] && Array.isArray(_roleMap[role])) {
				_roleMap[role].map(feature => {
					if (features.indexOf(feature) >= 0) {
						hasPermission = true;
					}
				});
			}
		});
	}

	return hasPermission;
};

export const _isNewUser = (user) => {

	if (user && user.trialStart && user.trialStart > 1607558400) {
		return true;
	}
	return false;
}


export const _shareThemes = {
	"douglas-elliman": {
		"display_name": "Douglas Elliman",
		"header_link": "https://www.elliman.com/"
	},
	"eklund-gomes": {
		"display_name": "Eklund | Gomes",
		"header_link": "https://theeklundgomesteam.elliman.com"
	},
	"nestseekers": {
		"display_name": "NestSeekers",
		"header_link": "https://www.nestseekers.com/"
	},
	"serhant": {
		"display_name": "SERHANT",
		"header_link": "https://www.serhant.com/"
	},
	"bhsdm": {
		"display_name": "BHSDM",
		"header_link": "https://www.bhsusa.com/about-development-marketing"
	},
	"jintoorkar-team": {
		"display_name": "Jintoorkar Team",
		"header_link": "https://www.elliman.com/team/the-anil-jintoorkar-team/226514"
	}
}

export const _canSelfServe = (user) => {
	if (user.role && Array.isArray(user.role) && user.role.filter(role => ['admin', 'enterprise'].indexOf(role) >= 0).length > 0) {
		return false;
	}
	return true;

}